import moment from 'moment';
import 'moment/dist/locale/de';

const genderDef = { 'FRAU': 0, 'MANN':1,'MIXED': 2,'LEER': 3,'PRIVAT': 4,'DORMITORY': 5};
const stateDef = {'NORMAL': 0,'PROV': 1,'FIX': 2,'CHECKIN': 3,'NOSHOW': 4,'STORNO': 5,'CHECKEDOUT': 6};

const colorStyle = (col) => {
  if (!col) col = 0;
  const res = {backgroundColor:'#'+col.toString(16).padStart(6, '0')}
  var hell = 0.2126*Math.floor(col / 256 / 256)+0.7152*(Math.floor(col / 256) % 256)+0.0722*(col % 256);
  res.color = hell < 160?'#FFF':'#000';
  return res;
}
const colorStyleHex = (col) => {
  const res = {backgroundColor:col==='FFFFFF'?'transparent':'#'+col.toString(16).padStart(6, '0')}
  var hell = 0.2126*parseInt(col.slice(0, 2), 16)+0.7152*parseInt(col.slice(2, 4), 16)+0.0722*parseInt('ccddee'.slice(4, 6), 16);
  res.color = hell < 160?'#FFF':'#000';
  return res;
}

const changeBrighness = (col, f) => {
  let res = '';
  for (let i = 0; i<3; i++) {
    let c = Math.floor(parseInt(col.slice(i*2, i*2+2), 16) * f);
    if (c > 255) c = 255;
    res += c.toString(16).padStart(2, '0');
  }
  return res;
}


  const LegendEntry = ({farbschema, c, label}) => {
    let col = '999999';
    if (farbschema==='ag') {
      col = c.farbe.slice(1);
      label = c.firma;
    }
    else if (farbschema==='bc') {
      col = c.farbe.slice(1);
      label = c.bezeichnung;
    }
    else if (!c.br) {
      c.reservation_id = 1;
      col = getCellcolor(farbschema, c, 0);
    }
    const brArr = farbschema==='ag'?[1]:[0,1,2];
    return (
      <tr>
        <td>
  {brArr.map((el, k)=> {
    let col2 = changeBrighness(col, k===0?0.75:(k===1?1:1.25));
    return (
          <div className="color" key={k} style={{backgroundColor:'#'+col2}} />
  )})}
        </td>
        <td>
          <div>{label}</div>
        </td>
      </tr>
    )
  }

  const LegendShade = () => (
    <tr><td colSpan={2}>
    {['Fixed', 'Normal', 'Temporary'].map((t, k)=> {
      let col2 = changeBrighness('999999', k===0?0.75:(k===1?1:1.25));
      return (
          <div key={k} style={{...colorStyleHex(col2), display:'inline-block', padding:'0.1em 0.5em', fontSize:'0.8em'}} >{t}</div>
    )})}
    </td></tr>
  )

  const Legende = ({farbschema, agenten, bookingchannels}) => {
    let res = [];
    if (farbschema==='ge') {
      res.push(['Female', 'Male', 'Mixed', 'Empty'].map((g, k)=> (
        <LegendEntry key={k} farbschema={farbschema} c={{geschlecht:k}} label={g} />
      )))
      res.push(
        <LegendShade key={-1} />
      )
    }
    else if (farbschema==='ar' || farbschema==='de') {
      res.push(['Departing today', 'Arriaval today', 'Has Arrived today', 'Checked-in', 'partial payment ok', 'not checked-in or not paid', 'Checked-out', 'Empty (booked)', 'Others'].map((g, k)=> {
        if (farbschema==='de' && k===4) return null;
        return (<LegendEntry key={k} farbschema={farbschema} c={{legend:k}} label={g} />)
      }))
      res.push(
        <LegendShade />
      )
    }
    else if (farbschema==='ag') {
      res = agenten.map((ag, k)=>(<LegendEntry key={k} farbschema={farbschema} c={ag} />));
    }
    else if (farbschema==='bc') {
      res = bookingchannels.map((bc, k)=>(<LegendEntry key={k} farbschema={farbschema} c={bc} />));
    }
    return (
      <table className="legend">
        <tbody>
        {res}
        </tbody>
      </table>
    )
}
  
  const getCellcolor = (farbschema, cell, heute, agenten, bookingchannels) => {
    if (!cell.reservation_id) return 'FFFFFF';

    let col = 'FFFFFF';
    if (farbschema==='ge') {
      return getGenderCol(cell.geschlecht)
    }
    if (farbschema==='ar' || farbschema==='de' ) {
      col = '4488ff';
      
      const nDays = moment(cell.abreise?.toString()).diff(moment(), 'days');
      let paymentDue = false;
      if (nDays >= cell.dauer) {
        paymentDue = false;
      }
      else if (nDays < 1) {
        paymentDue = parseFloat(cell.due) > 0;
      }
      else {
        const futureNights = cell.netto / cell.dauer * nDays;
        paymentDue = parseFloat(cell.due) > futureNights;
      }
      if (cell.geschlecht===genderDef.LEER || cell?.legend===7) col = '888888';  
      //Eingechecked und nicht bezahlt (nur fuer "Ankunft") ("CheckinNotPayed" oder "NotCheckedIn" oder "CheckinPartialPayment")
      else if ((cell.status===stateDef.CHECKIN && cell.bezahlt===0 && farbschema==='ar') || cell?.legend===5) {
        col = (paymentDue || cell?.legend===5)?'FF0033':'FF00FF'; 
      }
      //Ausgechecked und zu viel bezahlt (nur fuer "Ankunft") ("CheckinPartialPayment")
      else if ((cell.status===stateDef.CHECKEDOUT && cell.due!=="" && parseFloat(cell.due)<0 && farbschema==='ar') || cell?.legend===4) { 
        col = 'FF00FF';
      }
      //Ausgecheckt und nicht bezahlt ("CheckinNotPayed" oder "NotCheckedIn")
      else if ((cell.status===stateDef.CHECKEDOUT && cell.bezahlt===0) || cell?.legend===5) col = 'FF0000';
      // Ankunft vor heute und weder eingecheckt, ausgecheckt noch storno ("CheckinNotPayed" oder "NotCheckedIn")
      else if (cell.status!==stateDef.CHECKIN && cell.status!==stateDef.STORNO && cell.status!==stateDef.CHECKEDOUT && cell.ankunft<heute) {
        col = 'FF0033';
      }
      // ausgecheckt (abwesend) ("CheckedOut")
      else if (cell.status===stateDef.CHECKEDOUT || cell?.legend===6) {
        col = 'aaaaaa';
      }
      //Ankunft heute und eingechecked ("ArrivedToday")
      else if ((cell.ankunft===heute && cell.status===stateDef.CHECKIN) || cell?.legend===2) col = '00ee00';
      //Ankunft heute und noch nicht eingechecked ("ArrivalToday")
      else if (cell.ankunft===heute  || cell?.legend===1) col = 'ffee00';
      //Abreise heute und nicht ausgecheckt ("DepartureToday")
      else if ((cell.abreise===heute && cell.status!==stateDef.CHECKEDOUT) || cell?.legend===0) col = 'ff9900';
      //Abreise vor heute und nicht ausgecheckt und nicht storno (nur fuer "Abreise") ("CheckinNotPayed" oder "NotCheckedIn")
      else if (cell.status!==stateDef.STORNO && cell.status!==stateDef.CHECKEDOUT && cell.abreise<heute && farbschema==='de') {
        col = 'FF0033';
      }
      // Ankunft vor heute und weder ausgecheckt noch storno ("InHouse")
      else if ((cell.status!==stateDef.STORNO && cell.status!==stateDef.CHECKEDOUT && cell.ankunft<heute) || cell?.legend===3) {
        col = '009900'
      }
    } 
    else if (farbschema==='ag') {
      col = 'eeeeee';
      const ag = agenten?.find((ag)=>ag.id_agent===cell.id_agent)
      if (ag) {
        col = ag.farbe.slice(1);
      }
    }
    else if (farbschema==='bc') {
      col = 'eeeeee';
      const ag = bookingchannels?.find((bc)=>bc.id===cell.id_buchungskanal)
      if (ag) {
        col = ag.farbe.slice(1);
      }
    }
    if (farbschema==='ge' || farbschema==='ar' || farbschema==='de') {
      if (cell.status===1 || cell.legend===1) {
        col = changeBrighness(col, 1.25);
      }
      else if (cell.status===2 || cell.legend===2) {
        col = changeBrighness(col, 0.75);
      }
    }
  return col;
  }

  const getPrefix = (cell) => {
    let prefix = "";
    switch (cell.status) {
      case stateDef.CHECKIN:
        prefix = "!";
        break;
      case stateDef.NOSHOW:
        prefix = "X";
        break;
      case stateDef.STORNO:
        prefix = "x";
        break;
      case stateDef.CHECKEDOUT:
        prefix = "^";
        break;
      default:
        prefix = "";
    }

    switch(cell.id_buchungskanal) {
      case 5: //Verlängerung = 5
        prefix = "+>" + prefix;
        break;
      case 6: //roomChange = 6
        prefix = "->" + prefix;
        break;
      default:
        break;
    }

    if (cell.erinnerung) {
      prefix = "⏰" + prefix;
    }
    if (cell.bezahlt) {
      prefix = "$" + prefix;
    }
    if (cell.wichtig) {
      prefix = "⚠*" + prefix;
    }

    if (cell.zusatzleistung) {
      if (prefix) {
        prefix = prefix + " " + cell.zusatzleistung;
      }
      else {
        prefix = cell.zusatzleistung;
      }
    }

    if (prefix) {
      prefix = prefix + " ";
    }

    return prefix;
  }

  const getGenderK = (g) => {
    switch(g) {
      case genderDef.FRAU:
        return 'W';
      case genderDef.MANN:
        return 'M';
      case genderDef.MIXED:
        return 'X';
      case genderDef.LEER:
        return 'E';
      case genderDef.PRIVAT:
        return 'P';
      case genderDef.DORMITORY:
        return 'D';
      default:
        return '';
    }
  }

  const getGenderCol = (g) => {
    switch(g) {
      case genderDef.FRAU:
        return 'E7408B';
      case genderDef.MANN:
        return '0DD8D1';
      case genderDef.MIXED:
        return 'ffcc00';
      case genderDef.LEER:
        return '0074E7';
      default:
        return 'FFFFFF';
    }

  }

  export { colorStyle, colorStyleHex, Legende, getCellcolor, getPrefix, getGenderK, getGenderCol}